import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {debounceTime} from 'rxjs/operators';
import {ApiKeyFilter} from './apikey.filter';
import {AuthService} from '../services/auth.service';
import {EnvService} from '../services/env.service';
import {SettingsPersistenceService} from '../services/settings-persistence.service';

@Component({
  selector: 'micro-apikeys',
  templateUrl: './apikeys.component.html'
})
export class ApiKeysComponent implements OnInit {
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  filter: ApiKeyFilter = new ApiKeyFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  reloadDebouncer: EventEmitter<any> = new EventEmitter<any>();
  pageSettings: SettingsPersistenceService;
  protected isCompanyAdmin: boolean;

  constructor(private auth: AuthService,
              private env: EnvService,
              private http: HttpClient) {
  }

  ngOnInit(): void {
    this.isCompanyAdmin = this.auth.isCompanyAdmin();
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro-apikeys');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    this.reloadDebouncer.pipe(debounceTime(50)).subscribe(() => {
      this.reloadDebounced();
    });
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(() => {
      this.reload();
    });
    this.reload();
  }

  reload(): void {
    this.reloadDebouncer.emit();
  }

  reloadDebounced(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', '' + (this.paginator.pageIndex || 0))
      .set('size', '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize));

    this.http.get(`${this.env.e.url}/auth/apikeys`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
    });
  }
}
